var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlustracionMontana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 138,
    viewBox: "0 0 183 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5479 1.39062H83.498V45.6575H84.5479V1.39062Z",
    fill: "#00738A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5469 1.30244C84.5469 1.30244 95.9975 -3.25673 103.939 4.68495C111.881 12.6266 121.734 8.40817 121.734 8.40817C121.734 8.40817 114.528 17.591 100.998 16.2118C87.4677 14.8325 84.5469 20.4644 84.5469 20.4644",
    fill: "#00738A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92414 137.249C5.47009 137.249 3.63986 133.166 5.93823 130.587L81.1688 46.1917C82.6719 44.5054 85.2722 44.3976 86.9098 45.9535L175.738 130.349C178.357 132.838 176.596 137.249 172.983 137.249H8.92414Z",
    fill: "#00738A",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.211 87.0185L126.936 95.998L112.707 84.9354L101.699 96.3094L87.8117 80.9045L76.4628 94.9314L64.8865 86.6998L48.6162 102.936C48.6162 102.936 46.2139 94.678 43.9902 87.3662L83.6955 43.1094L130.211 87.0185Z",
    fill: "#CCE6E9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustracionMontana);
export default __webpack_public_path__ + "static/media/ilustracion-montana.100e7e515a0710ac05b216cab98709f9.svg";
export { ForwardRef as ReactComponent };